export const URL_PARAMS = {
  INCLUDES: 'includes',
  EXCLUDES: 'excludes',
  FROM_LIST: 'from_list',
  GROUP_IDS: 'group_ids',
  TOKEN: 'tk',
  APP_VERSION: 'app_version',
}